import { render, staticRenderFns } from "./HomeMain.vue?vue&type=template&id=b5f5d376&scoped=true"
import script from "./HomeMain.vue?vue&type=script&lang=js"
export * from "./HomeMain.vue?vue&type=script&lang=js"
import style0 from "./HomeMain.vue?vue&type=style&index=0&id=b5f5d376&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5f5d376",
  null
  
)

export default component.exports